import Footer from "../../components/common/layout/Footer";
import { Breadcrumbs, IntroSection, OtherServices, HowItWork, PricingPlan, WhySSL, PlanIncluded } from "@/components/features/cyberSecurity";
import SEO from "@/components/common/seo/seo";
import CallToAction from "@/components/common/sections/CallToAction";
import { FAQ } from "@/components/features/cyberSecurity";

export default function AiSolutions() {
    return (
        <div>
            <SEO
                title="Cybersecurity Services - SAN micron"
                description="Secure Your Business Today Protect your Digital World with SAN micron Discover cutting-edge cyber security solutions tailored to safeguard your business from evolving digital threats."
            />
            <Breadcrumbs />
            <IntroSection />
            <OtherServices />
            <PricingPlan />
            <PlanIncluded />
            <WhySSL />
            <HowItWork />
            <CallToAction
                title="Secure Your Business Today"
            />
            <FAQ />
            <Footer />
        </div>
    );
}